import axios from "axios";

const putClinic = async (baseUrl, token, doctorId, clinicBody) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + "/doctor/" + doctorId + "/clinic", clinicBody, config)
        .then((res) => {
            putResponse = {
                status: res.status,
                data: res.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return putResponse
}

export default putClinic;